var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTakePhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/take-photo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M23,6.8125 L23,19.1875 C23,20.3261719 22.0761719,21.25 20.9375,21.25 L3.0625,21.25 C1.92382812,21.25 1,20.3261719 1,19.1875 L1,6.8125 C1,5.67382812 1.92382812,4.75 3.0625,4.75 L6.84375,4.75 L7.37225723,3.33631134 C7.67303848,2.53282928 8.44219589,2 9.30157089,2 L14.694149,2 C15.553524,2 16.3226395,2.53282928 16.6234207,3.33631134 L17.15625,4.75 L20.9375,4.75 C22.0761719,4.75 23,5.67382812 23,6.8125 Z M17.15625,13 C17.15625,10.1554604 14.8445396,7.84375 12,7.84375 C9.15546036,7.84375 6.84375,10.1554604 6.84375,13 C6.84375,15.8445396 9.15546036,18.15625 12,18.15625 C14.8445396,18.15625 17.15625,15.8445396 17.15625,13 Z M15.78125,13 C15.78125,15.0839844 14.0839844,16.78125 12,16.78125 C9.91601562,16.78125 8.21875,15.0839844 8.21875,13 C8.21875,10.9160156 9.91601562,9.21875 12,9.21875 C14.0839844,9.21875 15.78125,10.9160156 15.78125,13 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon/take-photo",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "camera",
    fill: "#43575A",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTakePhoto);
export default __webpack_public_path__ + "static/media/take-photo.4ff6007f.svg";
export { ForwardRef as ReactComponent };